import React, { useState, useEffect } from "react";

import { LEGIT_SERVICE_CONFIG } from "common";

import { connect } from "react-redux";
import { legit } from "apex-legit-service";
import { apiToken } from "../../services/legit/token";
import { RootAction, RootState } from "StoreTypes";
import { bindActionCreators, Dispatch as reduxDispatch } from "redux";
import { useParams } from "react-router";
import moment from "moment";
import { fileDataFormat } from "utils/dateFormat";
import ReportPicker from "components/ReportPicker";
import SummarySection from "../SummarySection";
import DetailedView from "../DetailedView";
import { removeApiToken } from "components/APITokenPersistence";
import {
  alertsRequest,
  reportsRequest,
  setSliceDate,
  setSummaryDate,
  slicesRequest,
  summaryRequest,
} from "../../services/reports/actions";
import { Slice } from "../../types";
import {
  fetchErrorDetails,
  fetchSlices,
} from "../../services/reports/selectors";
import useInterval from "utils/useInterval";

export interface Props {
  token: string | null;
  logout: () => void;
  fetchReport: (reportDetails: Slice, token: string | null) => void;
  errorDetails: any;
  fetchSlices: (date: string, token: string | null) => void;
  fetchSummary: (date: string, token: string | null) => void;
  fetchAlerts: (token: string | null) => void;
  setSlice: (slice: Slice) => void;
  setSummaryDate: (date: string) => void;
}

const Reports = ({
  token,
  logout,
  errorDetails,
  fetchReport,
  fetchSlices,
  fetchSummary,
  fetchAlerts,
  setSlice,
  setSummaryDate,
}: Props) => {
  const { date, sliceid } = useParams() as any;

  const [reportDetails, setReportDetails] = useState({
    date: date ? date : moment().format(fileDataFormat),
    id: sliceid ? sliceid : "latest",
  });

  useEffect(() => {
    fetchSummary(moment().format(fileDataFormat), token);
  }, [fetchSummary, token]);

  useInterval(() => {
    fetchSummary(moment().format(fileDataFormat), token);
  }, 60000);

  useEffect(() => {
    const tempDate = date ? date : moment().format(fileDataFormat);
    const tempReportDetails: Slice = {
      date: tempDate,
      id: sliceid ? sliceid : "latest",
    };
    setSummaryDate(moment().format(fileDataFormat));
    setSlice(tempReportDetails);
    setReportDetails(tempReportDetails);
    fetchAlerts(token);
    fetchReport(tempReportDetails, token);
    fetchSlices(tempDate, token);
  }, [
    date,
    fetchAlerts,
    fetchReport,
    fetchSlices,
    setSlice,
    setSummaryDate,
    sliceid,
    token,
  ]);

  useEffect(() => {
    if (errorDetails) {
      if (errorDetails.status === 401) {
        removeApiToken();
        logout();
      }
    }
  }, [errorDetails, logout]);

  return (
    <div id="report-view">
      <SummarySection />
      <DetailedView reportDetails={reportDetails} />
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: apiToken(state),
  slices: fetchSlices(state),
  errorDetails: fetchErrorDetails(state),
});

const mapDispatchToProps = (dispatch: reduxDispatch<RootAction>) =>
  bindActionCreators(
    {
      logout: () => legit.logout(LEGIT_SERVICE_CONFIG, { apexUser: true }),
      fetchReport: (reportDetails, token) =>
        reportsRequest(reportDetails, token),
      fetchSlices: (date, token) => slicesRequest(date, token),
      fetchAlerts: (token) => alertsRequest(token),
      fetchSummary: (date, token) => summaryRequest(date, token),
      setSlice: (reportDetails) => setSliceDate(reportDetails),
      setSummaryDate: (date) => setSummaryDate(date),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
